import { DetailColumnFormat } from './ColumnsFormatters/DetailColumnFormat';
import { FileColumn } from './ColumnsFormatters/FileColumn';
import { ButtonColumn } from './ColumnsFormatters/ButtonColumn';

export const columns = (onEye) => [
	{
		dataField: 'no',
		text: 'No.',
	},
	{
		dataField: 'Resolucion',
		text: 'Resolucion / Recomendacion',
	},
	{
		dataField: 'Fundamento',
		text: 'Fundamento Legal',
	},
	{
		dataField: 'Texto',
		text: 'Texto',
	},
	{
		dataField: 'Organo',
		text: 'Organo Colegiado',
	},
	{
		dataField: 'Fecha',
		text: 'Fecha limite de Cumplimiento',
	},
	{
		dataField: 'id',
		text: 'Acciones',
		formatter: DetailColumnFormat,
		formatExtraData: {
			onEye,
		},
	},
];
export const organToCalendar = (organs = [], disableForm = false) => [
	{
		label: 'Seleccione Órgano Colegiado',
		name: 'organoId',
		type: 'dropdown',
		options: [...organs],
		column: 12,
		disabled: disableForm,
		organ: '',
		autoFocus: true,
	},
];
export const defaultOrganToCalendar = {
	organoId: '',
};
export const defaultValues = {
	tema: '',
	area_Responsable: '',
	text: '',
	Fundamento_Legal: '',
	articulo: '',
	para: '',
};

export const defaultSessions = {
	id: '',
	title: '',
	start: '',
	end: '',
	allDay: true,
	organoId: '',
};

export const columnsTopics = (onEye) => [
	// {
	// 	dataField: 'No.',
	// 	text: 'No.',
	// 	classes: 'text-center',
	// 	headerClasses: 'text-center',
	// },
	{
		dataField: 'tipo',
		text: 'Tipo',
		classes: 'text-center',
		headerClasses: 'text-center',
		width: '7%',
	},
	{
		dataField: 'numeroResolucion',
		text: 'Tema',
		classes: 'text-center',
		headerClasses: 'text-center',
		width: '7%',
	},
	{
		dataField: 'comite',
		text: 'Unidad Adminstrativa',
		classes: 'text-center',
		headerClasses: 'text-center',
		width: '7%',
	},
	{
		dataField: 'fundamentoJuridico',
		text: 'Fundamento Legal',
		classes: 'text-center',
		width: '50%',
		headerClasses: 'text-center',
	},

	{
		dataField: 'Oficio',
		text: 'Oficio',
		width: '7%',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: FileColumn,
		formatExtraData: {},
	},
	{
		dataField: 'Tarjeta',
		text: 'Tarjeta',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: FileColumn,
		width: '7%',
		formatExtraData: {},
	},
	{
		dataField: 'Presentación',
		text: 'Presentación',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: FileColumn,
		width: '7%',
		formatExtraData: {},
	},
	{
		dataField: 'DocumentosAdicionales',
		text: 'Documentos Adicionales',
		classes: 'text-center',
		headerClasses: 'text-center',
		width: '7%',
		formatter: FileColumn,
		formatExtraData: {},
	},
	{
		dataField: 'VerDetalle',
		text: 'Ver Detalle',
		classes: 'text-center',
		headerClasses: 'text-center',
		width: '7%',
		formatter: DetailColumnFormat,
		formatExtraData: {
			onEye,
		},
	},
	{
		dataField: 'Enviar',
		text: 'Enviar a Aprobación',
		classes: 'text-center',
		headerClasses: 'text-center',
		width: '7%',
		formatter: ButtonColumn,
		formatExtraData: {
			onEye,
		},
	},
];

export const itemsTopics = [
	{
		Tema: 'tema22',
		UnidadAdminstrativa: 'Unidad',
		FundamentoLegal: 'Fundamento',
		Detalle: 'Detalle',
		perfil: 'Enlace',
		totalIcons: 4,
		dataMinos: [
			{
				idEntidad: 'entidad',
				tipo: 'tipo',
				entidad: 'entidad',
				ruta: 'ruta',
				title: 'Oficio',
				nombre: 'ss',
			},
			{
				idEntidad: 'entidad',
				tipo: 'tipo',
				entidad: 'entidad',
				ruta: 'ruta',
				title: 'Tarjeta',
				nombre: '',
			},
			{
				idEntidad: 'entidad',
				tipo: 'tipo',
				entidad: 'entidad',
				ruta: 'ruta',
				title: 'Presentacion',
				nombre: '',
			},
			{
				idEntidad: 'entidad',
				tipo: 'tipo',
				entidad: 'entidad',
				ruta: 'ruta',
				title: 'Adicionales',
				nombre: '',
			},
		],
	},
	{
		Tema: 'tema21',
		UnidadAdminstrativa: 'Unidad',
		FundamentoLegal: 'Fundamento',
		Detalle: 'Detalle',
		perfil: 'Enlace',
		totalIcons: 4,
		dataMinos: [
			{
				idEntidad: 'entidad',
				tipo: 'tipo',
				entidad: 'entidad',
				ruta: 'ruta',
				title: 'Oficio',
				nombre: '',
			},
			{
				idEntidad: 'entidad',
				tipo: 'tipo',
				entidad: 'entidad',
				ruta: 'ruta',
				title: 'Tarjeta',
				nombre: '',
			},
			{
				idEntidad: 'entidad',
				tipo: 'tipo',
				entidad: 'entidad',
				ruta: 'ruta',
				title: 'Presentacion',
				nombre: '',
			},
			{
				idEntidad: 'entidad',
				tipo: 'tipo',
				entidad: 'entidad',
				ruta: 'ruta',
				title: 'Adicionales',
				nombre: '',
			},
		],
	},
];

//ADD TOPICS
export const addTopicsInputs = (institutions = [], fundamentals = []) => [
	{
		label: '* Nombre de Tema',
		name: 'nombreTema',
		placeholder: 'Nombre de Tema',
		type: 'text',
		column: 12,
	},
	{
		label: '* Área Administrativa Responsable',
		name: 'instituciones',
		type: 'search-multiple',
		options: [...institutions],
		column: 12,
	},
	{
		label: '* Fundamento Legal',
		name: 'fundamentoLegal',
		type: 'dropdown',
		options: [...fundamentals],
		column: 12,
	},
	{
		label: '* Especificar Articulo, Fraccion Inciso, Subincisso o lo que aplique',
		name: 'detalleFundamento',
		type: 'text',
		column: 12,
	},
	{
		label: '* Es para:',
		name: 'tipo',
		type: 'dropdown',
		options: [
			{ value: 'PA', text: 'Aprobacion' },
			{ value: 'D', text: 'Dictaminacion' },
			{ value: 'PC', text: 'Conocimiento' },
		],
		column: 12,
	},
];
export const editTopicsInputs = (institutions = [], disableForm) => [
	{
		label: '* Nombre de Tema',
		name: 'nombreTema',
		placeholder: 'Nombre de Tema',
		type: 'text',
		column: 12,
		disabled: disableForm,
	},
	{
		label: '* Area Administrativa Responsable',
		name: 'instituciones',
		type: 'search-multiple',
		options: [...institutions],
		column: 12,
		disabled: disableForm,
	},
	{
		label: '* Fundamento Legal',
		name: 'fundamentoLegal',
		type: 'text',
		column: 12,
		disabled: disableForm,
	},
	{
		label: '* Especificar Articulo, Fraccion Inciso, Subincisso o lo que aplique',
		name: 'detalleFundamento',
		type: 'text',
		column: 12,
		disabled: disableForm,
	},
	{
		label: '* Es para:',
		name: 'tipo',
		type: 'dropdown',
		options: [
			{ value: 'PA', text: 'Aprobacion' },
			{ value: 'D', text: 'Dictaminacion' },
			{ value: 'PC', text: 'Conocimiento' },
		],
		column: 12,
		disabled: disableForm,
	},
];

export const defaultAddTopics = {
	id: '',
	idSesion: '',
	nombreTema: '',
	instituciones: [],
	fundamentoLegal: [],
	detalleFundamento: '',
	tipo: null,
};

export const action_buttons = (add) => [
	{
		title: 'Agregar Tema',
		color: 'light-secondary',
		onClick: add /*className: 'd-none'*/,
	},
];
export const update_button = (remove, add, disableform) => [
	{
		title: 'Eliminar este tema',
		color: 'btn btn-danger',
		onClick: remove,
		disabled: disableform,
	},
	{
		title: 'Actualizar Tema',
		color: 'success',
		onClick: add,
		className: 'ml-4',
		disabled: disableform,
	},
];
